import { createSelector } from 'reselect';
import {
  PRICE_COUNTER_PROPOSAL_THRESHOLD,
  PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD,
} from 'Store/booking/proposals/constants';
import { getBlockInputDepartureDate, getCalendarLoading } from 'Store/calendar/calendar.selector';
import { priceRemoteSelector } from 'Store/price-remote/priceRemote.selector';
import { getDepartureDate, getTripDuration } from 'Store/trip-criteria/tripCriteria.selector';
export const priceOfStaySelector = createSelector(
  priceRemoteSelector,
  ({ priceOfStay: { data } }) => data,
);
export const priceOfStayArgsSelector = createSelector(
  priceRemoteSelector,
  ({ priceOfStay: { priceOfStayArgs } }) => priceOfStayArgs,
);
export const proposalsSelector = createSelector(priceOfStaySelector, (data) => {
  const proposals = (data as { proposals?: Record<string, unknown> })?.proposals;
  return proposals || {};
});
export const priceOfStayIsLoadingSelector = createSelector(
  getCalendarLoading,
  priceRemoteSelector,
  getDepartureDate,
  getBlockInputDepartureDate,
  getTripDuration,
  (
    calendarIsLoading,
    { priceOfStay: { isLoading: priceOfStayIsLoading, lastRequestId } },
    departureDate,
    blockInputDepartureDate,
    duration,
  ) => {
    return (
      calendarIsLoading ||
      ((lastRequestId !== -1 || (!blockInputDepartureDate && !!departureDate && !!duration)) &&
        priceOfStayIsLoading)
    );
  },
);
export const shouldDisplayAlternativePriceTitleSelector = createSelector(
  priceRemoteSelector,
  ({ priceOfStay: { data } }) => {
    const gap = data?.gap ?? 0;
    return gap >= PRICE_COUNTER_PROPOSAL_THRESHOLD && gap < PRICE_COUNTER_PROPOSAL_MAX_THRESHOLD;
  },
);
